module.exports = __webpack_public_path__ + "src/img/gps.466aaa9f.svg";